import config from 'config';
import createApolloClient from 'graphql/createApolloClient';
import RequestHeaders from 'app/constants/requestHeaders';
import { CognitoTokenManager } from 'app/modules/auth/utils/cognitoTokenManager';

export const createInsightsApolloClient = (
  token: string,
  accountIdOverride?: number,
) => {
  const accountId =
    accountIdOverride ?? CognitoTokenManager.getSelectedAccountId();

  return createApolloClient(`${config.ANALYTICS_ENDPOINT}/graphql`, {
    [RequestHeaders.Authorization]: `Bearer ${token}`,
    ...(accountId && { [RequestHeaders.AccountId]: String(accountId) }),
  });
};
